// extracted by mini-css-extract-plugin
export default {"container":"mobileMenu-module__container__hDUYR","title":"mobileMenu-module__title__pV6e+"};